import { WidgetInstance } from 'friendly-challenge'

export default class FriendlyCaptcha extends HTMLElement {
  connectedCallback() {
    this.element = this.querySelector('div[data-sitekey]')
    if (!this.element) return
    this._originalHTML = this.innerHTML
    const options = {
      sitekey: this.element.getAttribute('data-sitekey'),
      language: this.element.getAttribute('data-lang')
    }
    this.widget = new WidgetInstance(this.element, options)
  }

  disconnectedCallback() {
    this.widget?.destroy()
    this.widget = null
    this.element = null
    if (this._originalHTML) {
      this.innerHTML = this._originalHTML
      this._originalHTML = null
    }
  }
}
